module.exports = __webpack_public_path__ + "static/index/img/baikal-1004.5312205c.jpg";